<template>
  <div id="scroll" class="lower-page property-list bg-white">
    <navbar />
    <div class="lower-mv" :style="lowermv">
      <h2 v-html="pageTitle" />
    </div>
    <section class="wrapper">
      <template v-if="!$route.params.type">
        <div class="search-tab">
          <router-link :to="{ name: 'Client Property List', params: {lang: activeLanguage}}" :class="filter.prefecture ? null : 'current'">{{ $t('一覧から探す') }}</router-link>
          <router-link :to="{ name: 'Client Property Map', params: {lang: activeLanguage}}" :class="filter.prefecture ? 'current' : null">{{ $t('都道府県から探す') }}</router-link>
        </div>
        <div class="search-prefectures" v-if="filter.prefecture">
          <h2>{{ $t('都道府県物件一覧', [$t(filter.prefecture[0].toUpperCase()+filter.prefecture.slice(1))]) }}</h2>
          <router-link :to="{ name: 'Client Property Map', params: {lang: activeLanguage}}">{{ $t('都道府県検索に戻る') }}</router-link>
        </div>
      </template>
      <div class="lower-category">
        <span>{{$t('カテゴリー')}}</span>
        <ul>
          <li v-for="(property_category) in property_categories" :key="property_category">
            <a @click="changeCategory(property_category)" :class="activeCategory(property_category)">{{ $t(property_category || 'すべて') }}</a>
          </li>
        </ul>
      </div>
      <div class="lower-category">
        <span>{{$t('ステータス')}}</span>
        <ul>
          <li v-for="(report_status) in report_statuses" :key="report_status">
            <a @click="filter.status = report_status" :class="activeStatus(report_status)">{{ $t(report_status || 'すべて') }}</a>
          </li>
        </ul>
      </div>
      <div class="property_contents_list" v-if="properties">
        <ul>
          <li v-for="(item, index) in displayedProperties" :key="index">
            <property-item :item="item" />
          </li>
        </ul>
      </div>

      <div v-if="properties">
        <div v-show="filteredProperties.length > parPage">
        <paginate
          v-model="currentPage"
          :page-count="getPageCount"
          :page-range="3"
          :click-handler="changePage"
          :active-class="'pager-current'"
          :prev-link-class="'lower-pager-fast'"
          :next-link-class="'lower-pager-last'"
          :prev-text="''"
          :next-text="''"
          :container-class="'lower-pager'"
          :no-li-surround="true"
          href="#scroll" v-smooth-scroll
          class="w-50 ml-auto mr-auto">
        </paginate>
        </div>
      </div>
    </section>
    <footerClient />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import { mapState, mapActions } from 'vuex'
import paginate from 'vuejs-paginate'
import propertyItem from './components/property-item.vue'
import { businessPropertyValues, rentalResidentialPropertyValues, rentalCommercialPropertyValues } from '../../../assets/data/values'

export default {
  data () {
    let categories, statuses
    switch (this.$route.params.type) {
      case 'residential-property-list':
        categories = [null].concat(rentalResidentialPropertyValues.propertyTypes)
        statuses = [null].concat(rentalResidentialPropertyValues.reportStatus)
        break
      case 'commercial-property-list':
        categories = [null].concat(rentalCommercialPropertyValues.propertyTypes)
        statuses = [null].concat(rentalCommercialPropertyValues.reportStatus)
        break
      default:
        categories = [null].concat(Object.values(businessPropertyValues.propertyTypes).flat())
        statuses = [null].concat(businessPropertyValues.reportStatus)
        break
    }
    return {
      property_categories: categories,
      report_statuses: statuses,
      activeLanguage: this.$route.params.lang,
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      },
      filter: {
        category: null,
        status: null,
        prefecture: this.$route.params.prefecture
      },
      parPage: 12,
      currentPage: 1
    }
  },
  created () {
    this.soldProperties()

    const params = { language: this.activeLanguage }
    if (this.$route.params.type) {
      // "residential-property-list" -> "rental-residential"
      params.type = `rental-${this.$route.params.type.replace('-property-list', '')}`
    }
    this.propertyList(params)
  },
  computed: {
    ...mapState('propertyClient', ['properties', 'newStatus']),
    pageTitle: function () {
      if (this.$route.params.type) {
        // "residential-property-list" -> "rental-residential-property"
        return this.$t(`rental-${this.$route.params.type.replace('-list', '')}`)
      } else {
        return this.filter.prefecture ? this.$t('都道府県から売買物件を探す') : this.$t('business-property')
      }
    },
    filteredProperties: function () {
      return this.properties
        .filter(this.filterByCategory)
        .filter(this.filterByStatus)
        .filter(this.filterByPrefecture)
    },
    displayedProperties: function () {
      let current = this.currentPage * this.parPage
      if (this.filteredProperties.length < 12) {
        current = 12
      }
      const start = current - this.parPage
      return this.filteredProperties.slice(start, current)
    },
    getPageCount: function () {
      return Math.ceil(this.filteredProperties.length / this.parPage)
    }
  },
  methods: {
    ...mapActions('propertyClient', ['propertyList']),
    filterByCategory: function (property) {
      if (this.filter.category === null) {
        return true
      }
      return (property[0].property_category === this.filter.category)
    },
    filterByStatus: function (property) {
      if (this.filter.status === null) {
        return true
      }
      return (property[0].report_status === this.filter.status)
    },
    filterByPrefecture: function (property) {
      if (!this.filter.prefecture) {
        return true
      }
      return (property[0].prefecture === this.filter.prefecture)
    },
    changeCategory: function (category) {
      if (this.filter.category === category) {
        return
      }

      this.filter.category = category
      this.changePage(1)
    },
    changePage: function (pageNum) {
      this.currentPage = Number(pageNum)
    },
    activeCategory: function (value) {
      if (this.filter.category === value) {
        return 'category-current'
      }
    },
    activeStatus: function (value) {
      if (this.filter.status === value) {
        return 'category-current'
      }
    },
    soldProperties: function () {
      if (this.$route.params.sold) {
        this.filter.status = '販売済'
      }
    }
  },
  components: {
    navbar,
    footerClient,
    paginate,
    propertyItem
  }
}
</script>
